module.exports = __webpack_public_path__ + "img/c4.40edd2b3.png";